import React, { useEffect } from "react";
import "./offer-banner.css";

import { getAllBanner } from "../../../features/home/homeSlice";

import { useDispatch, useSelector } from "react-redux";

const Offer_banner = () => {
  const dispatch = useDispatch();

  const allbanners = useSelector((state) => state.home.allbanners);
  const banner = allbanners?.[0];

  useEffect(() => {
    dispatch(
      getAllBanner({
        banner_type_id: 1,
      }),
    );
  }, [dispatch]);

  const imageUrl = banner?.image
    ? process.env.REACT_APP_IMAGE_URL + banner.image
    : null;

  const isVideo = /\.(mp4|webm|ogg)$/i.test(banner?.image || "");

  if (!imageUrl) {
    return null;
  }

  return (
    <section className="Offer_banner_sec">
      <div className="offerbanerdiv">
        {isVideo ? (
          <video
            className="offerbanner"
            src={imageUrl}
            autoPlay
            loop
            muted
            playsInline
            preload="auto"
          >
            Your browser does not support the video tag.
          </video>
        ) : (
          <img className="offerbanner" src={imageUrl} alt="Bapat Opticians" />
        )}
      </div>
    </section>
  );
};

export default Offer_banner;